(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authors-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const button = document.getElementById('load-more-posts');
  const container = document.getElementById('author-posts');
  if (!button) return;

  button.addEventListener('click', function() {
    let page = parseInt(container.dataset.page) + 1;
    const author = container.dataset.author;

    fetch(window.location.pathname + '?page=' + (page + 1))
      .then(response => response.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newPosts = tempDiv.querySelectorAll('#author-posts .col-md-4');

        if (newPosts.length === 0) {
          button.style.display = 'none';
        } else {
          newPosts.forEach(post => container.appendChild(post));
          container.dataset.page = page;
        }
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer_service_faq"] && !Shopify.designMode) return;
  try {
    
    $( document ).ready(function() {
        $('.customer-service-faq--tab').on('click', function(e) {
            var target = $(this).data('target');
            $('.customer-service-faq--tab').removeClass('active');
            $(this).addClass('active');
            $('.customer-service-faq--tab_content').hide();
            $(target).fadeIn('fast');
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq2"] && !Shopify.designMode) return;
  try {
    
    $( document ).ready(function() {
        $('.faq_2--item_question').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).next().slideToggle();
            $(this).find('.fa').toggleClass('fa-plus').toggleClass('fa-minus');
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hubspot_blog"] && !Shopify.designMode) return;
  try {
    

function hsBlogFormatDateString($string) {
    var monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    var date = new Date($string);

    var year = date.getFullYear();
    var month = monthNames[date.getMonth()];
    var day = date.getDate();

    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }

    var formattedDate = month + ' ' + day + ', ' + year;

    return formattedDate;
}

$( document ).ready(function() {

    $('.hubspot-blog').each(function() {

        var block = $(this),
            feed = block.data('feed');
        
        $.ajax(feed, {
            accepts:{
              xml:"application/rss+xml"
            },
            dataType:"xml",
            success:function(data) {

                i            = 0;
                posts_holder = block.find('.js--hubspot-blog');

                $(data).find("item").each(function () {

                    if (i < 2) {

                        var el            = $(this),
                            body          = el.find("description").text(),
                            title         = el.find("title").text(),
                            link          = el.find("link").text(),
                            categories    = el.find("category"),
                            date          = el.find('pubDate').text(),
                            desc_obj      = $($.parseHTML( body )),
                            formattedDate = hsBlogFormatDateString(date),
                            image_src     = desc_obj.find('.hs-featured-image-link img').attr('src');
                            $body         = el.find("description").text();

                            $description = '';

                            $($body).each(function() {
                                if ( $(this).is('p')) {
                                    $description = $description + $(this).html();
                                }
                            });

                            html = '<div class="col-md-6 mb-30">'+
                                    '<article class="blog-item">'+
                                        '<div class="g--img-bg blog-item--image mb-10">'+
                                            '<img class="lazyload" data-src="' + image_src +'" />'+
                                        '</div>'+
                                        '<div class="blog-item--content">'+
                                            '<div class="blog-item--date mb-10">'+
                                                '<time><i class="fa fa-calendar" aria-hidden="true"></i>' + formattedDate + '</time>'+
                                            '</div>'+
                                            '<h3 class="blog-item--title mb-10">'+
                                                '<a href="' + link + '">' + title +'</a>'+
                                            '</h3>'+
                                            '<div class="post-excerpt-holder mb-10">' +
                                                $description.substring(0, 75) + '...' +
                                            '</div>' +
                                            '<a href="' + link + '" class="blog-item--link">' +
                                                'Read More' +
                                                '<i class="fa fa-caret-right"></i>' +
                                            '</div>' +
                                        '</div>'+
                                    '</article>'+
                                 '</div>';

                        $(html).appendTo(posts_holder);
                    }

                    i++;

                });

            } 
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_faq"] && !Shopify.designMode) return;
  try {
    
    $( document ).ready(function() {
        $('.product-faq--accordion_question').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).next().slideToggle();
            $(this).find('.ion').toggleClass('ion-plus').toggleClass('ion-minus');
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
(function () {

  function waitForSlick(callback) {
    if (window.jQuery && jQuery.fn && jQuery.fn.slick) {
      callback();
    } else {
      setTimeout(function () {
        waitForSlick(callback);
      }, 50);
    }
  }

  function initSection(section) {
    var slider = section.querySelector('.reviews-slick-slider');
    if (!slider || slider.classList.contains('slick-initialized')) return;

    jQuery(slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      speed: 400,
      cssEase: 'ease',
      prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next"></button>',
        customPaging: function (slider, i) {
          return '<button type="button"></button>'; // empty button for our custom SVG
        }
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.reviews-slider-section');
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  function boot() {
    waitForSlick(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section && section.classList.contains('reviews-slider-section')) {
      waitForSlick(function () {
        initSection(section);
      });
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider-alt"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.testimonial-slider-alt--slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      fade: true,
      prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next"></button>',
        customPaging: function (slider, i) {
          return '<button type="button"></button>'; // empty button for our custom SVG
        }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
